import './style.scss';

export default function Affiliates() {
    return (
        <div className="Affiliates">
            <div className="column first-column">
                <img src="/mok_bel.png" className="logo" />
            </div>
            <div className="column second-column">
                <img src="/impact4values.png" className="logo" />
            </div>
        </div>
    );
}
